import React, { Fragment, useState } from 'react';
import { useTranslate } from 'react-admin';

import EmployeeForm from './EmployeeForm';
import { EditButton, Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import { Business, Employee, Individual } from '~/types';
import { FormDataConsumer } from 'react-admin';

import { label } from '../EmployeeList';
import { usePermissions } from 'react-admin';
import { crudGetOne } from 'react-admin';
import { useDispatch } from 'react-redux';
import useCrudGetManyReference from '~/hooks/useCrudGetManyReference';
import { Alert } from '@material-ui/lab';
import CopyableUUID from '~/components/CopyableUUID';

type FormData = {
  formData: Individual;
  [x: string]: any;
};

interface Props {
  employeeRecord: Employee;
  businessRecord: Business;
  target: 'employees' | 'businesses';
  closeParent?: () => void;
}

const EmployeeEdit = (props: Props) => {
  const { employeeRecord, businessRecord, closeParent, target } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    closeParent && closeParent();
  };

  const { permissions } = usePermissions();
  const translate = useTranslate();
  const translateLabel = (key: string, args?: any): string => translate(label(key), args);
  const crudGetManyReference = useCrudGetManyReference('employees', target, businessRecord?.id);
  const dispatch = useDispatch();
  const name = `${employeeRecord.firstName || ''} ${employeeRecord.lastName || ''}`;
  const hasAffiliation = employeeRecord?.references
    ? employeeRecord?.references?.filter((reference) => !reference.deleted).length > 0
    : false;
  return (
    <Fragment>
      <EditButton
        onClick={handleOpen}
        disabled={!permissions?.includes('business.employee.update')}
      />
      <Drawer
        heading={`${translateLabel('editTeamMember')} "${employeeRecord.firstName || ''} ${
          employeeRecord.lastName || ''
        }"`}
        open={open}
        onClose={handleClose}
        subtitle={<CopyableUUID id={employeeRecord?.id} />}
      >
        <EditForm
          resource='employees'
          record={employeeRecord}
          closeParent={handleClose}
          withDelete={permissions?.includes('business.delete')}
          withDeleteConfirmation
          deleteButtonProps={{
            variant: 'delete',
            disabled: !permissions?.includes('business.employee.delete'),
          }}
          deleteConfirmationSettings={{
            variant: 'modal',
            modal: {
              heading: translateLabel('deleteTeamMember', { name }),
              content: (
                <>
                  {hasAffiliation && (
                    <Alert severity='warning' style={{ marginBottom: 24 }}>
                      {translateLabel('teamMemberHasAffiliationAlert')}
                    </Alert>
                  )}
                  {translateLabel('areYouSureYouWantTo')}
                </>
              ),
            },
          }}
          onDeleteSuccess={() => {
            target === 'employees' && dispatch(crudGetOne('employees', employeeRecord?.id, target));
            target === 'businesses' && crudGetManyReference();
          }}
        >
          <FormDataConsumer>
            {({ formData }: FormData) => {
              return <EmployeeForm businessRecord={businessRecord} scopedFormData={formData} />;
            }}
          </FormDataConsumer>
        </EditForm>
      </Drawer>
    </Fragment>
  );
};

export default EmployeeEdit;
